import api from '../../utils/helpers/api'

export interface MonitoringSPParams {
  page?: number
  per_page?: number
  id_batch?: number
  step?: number
  is_lulus?: number | boolean
  locus?: string
  users_username?: string
  nomor_pendaftaran?: string
  email?: string
  has_file_bermaterai?: boolean | string | number
  q?: string
  sort_field?: string
  sort_order?: 'asc' | 'desc'
}

export interface MonitoringSPData {
  file_surat_id: number
  nama_lengkap: string
  users_username: string
  email: string
  no_telepon: string
  locus: string
  lulus: number
  batch: number
  nomor_pendaftaran: string
  judul_proposal: string
  file_bermaterai: string | {url: string; path?: string; name?: string} | null
  url?: string  // Backend dapat mengembalikan URL langsung
  created_at?: string
  updated_at?: string
}

export interface MonitoringSPResponse {
  status: boolean
  message?: string
  data: {
    dashboard: {
      total_peserta_lulus: number
      sudah_upload_file: number
      belum_upload_file: number
      completion_ratio: number
    }
    filters: {
      status_upload: Array<{label: string; value: string}>
      batch: Array<{id: number; nama_batch: string; status: string; label: string}>
      locus: Array<{id: number; locus: string}>
    }
    data: {
      current_page: number
      data: MonitoringSPData[]
      per_page: number
      total: number
      last_page?: number
      from?: number
      to?: number
    }
  }
}

const monitoringSP = {
  /**
   * Get list monitoring SP dengan pagination & filter
   * GET /api/v1/monitoring-sp
   */
  getList: async (params?: MonitoringSPParams): Promise<MonitoringSPResponse> => {
    return (await api.get('/monitoring-sp', {params})) as Promise<MonitoringSPResponse>
  },

  /**
   * Download single file surat bermaterai
   * POST /api/v1/monitoring-sp/download
   * Response: File binary (PDF)
   */
  downloadFile: async (fileSuratId: number): Promise<any> => {
    return await api.post(
      '/monitoring-sp/download',
      {file_surat_id: fileSuratId.toString()},
      {responseType: 'blob'}
    )
  },

  /**
   * Download semua file surat bermaterai dalam ZIP
   * GET /api/v1/monitoring-sp/download-all
   * Response: File binary (ZIP)
   */
  downloadAll: async (params?: Omit<MonitoringSPParams, 'page' | 'per_page' | 'sort_field' | 'sort_order'>): Promise<any> => {
    return await api.get('/monitoring-sp/download-all', {
      params,
      responseType: 'blob',
    })
  },
}

export default monitoringSP
